/**
 * Currency formatting with explicit thousands separators.
 */
export function formatCents(cents) {
  return formatDollars(parseFloat(cents || 0) / 100);
}

export function formatDollars(dollars) {
  const value = parseFloat(dollars || 0);
  const negative = value < 0;
  const abs = Math.abs(value);
  const fixed = abs.toFixed(2);
  const [intPart, decPart] = fixed.split('.');
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${negative ? '-' : ''}$${withCommas}.${decPart}`;
}

export function formatIntegerWithCommas(value) {
  const num = Math.round(Number(value || 0));
  const negative = num < 0;
  const abs = Math.abs(num).toString();
  return `${negative ? '-' : ''}${abs.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}
